import { render, staticRenderFns } from "./ProductFeatures.vue?vue&type=template&id=4aad87aa&scoped=true&"
import script from "./ProductFeatures.vue?vue&type=script&lang=js&"
export * from "./ProductFeatures.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeatures.vue?vue&type=style&index=0&id=4aad87aa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aad87aa",
  null
  
)

export default component.exports